// extracted by mini-css-extract-plugin
export default {"voteFormContent":"vote-form_voteFormContent__W1Qo-","voteFormFooter":"vote-form_voteFormFooter__RWp1Z"};